import { TypeProductionEnum } from '@/config/types-production';

// Hardcoded holding UUIDs allowed to see the Presence Identify tab.
// Sourced from Angular AnalysisSectionService allowlist.
// NOTE: this list drifted from legacy — verified via live QA on 2026-07-07
// that corp.agriness.com shows "Identificar" for the demo holding below even
// though it wasn't in the ported list. A hardcoded allowlist is fragile by
// nature; consider replacing with a backend-driven module/feature flag.
export const IDENTIFY_ALLOWED_HOLDING_IDS: readonly string[] = [
  'd80762d8-8271-4906-a984-3d9453fadb9c',
  '1d73fd2e-dc79-43fa-bbcb-d123d00aa222',
  '922452c0-0272-40bd-b575-683d291debfd',
  'cf067b2d-de40-4296-9826-dd00033ec723', // Demo - Presence Migração
];

// Looker panel keys per production type — note the intentional typo 'techinical' matching backend.
export const LOOKER_PANEL_KEYS: Record<TypeProductionEnum, string> = {
  [TypeProductionEnum.SWINES]: 'techinical_assistant-swine-analysis',
  [TypeProductionEnum.POULTRY]: 'techinical_assistant-poultry-analysis',
  [TypeProductionEnum.DAIRY]: 'techinical_assistant-dairy-analysis',
  [TypeProductionEnum.LAYERS]: 'techinical_assistant-layers-analysis',
};
